import { Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TooltipButton } from "@/components/common/Tooltips";

// Botón de DEEP LINK (GRATIS, sin API key): abre la app de mapas del dispositivo
// (Google/Apple Maps/Waze) o la web con el enlace universal de Google Maps.
// NO embebe ningún mapa de pago. Si no hay coordenadas: muestra "Sin ubicación registrada"
// (o nada si hideIfEmpty).
export function BotonAbrirEnMapas({
  lat, lng,
  label = "Abrir en mapas",
  size = "sm",
  variant = "outline",
  className = "",
  hideIfEmpty = false,
  testid = "abrir-en-mapas",
}) {
  const has = lat != null && lng != null && !Number.isNaN(Number(lat)) && !Number.isNaN(Number(lng));
  if (!has) {
    if (hideIfEmpty) return null;
    return <span data-testid={`${testid}-vacio`} className="text-[11px] text-slate-400">Sin ubicación registrada</span>;
  }
  const url = `https://www.google.com/maps/search/?api=1&query=${Number(lat)},${Number(lng)}`;
  return (
    <TooltipButton tooltip="Abrir la ubicación en Google Maps (nueva pestaña)"
      data-testid={testid} type="button" size={size} variant={variant} className={`gap-1.5 ${className}`}
      onClick={() => window.open(url, "_blank", "noopener,noreferrer")}>
      <Navigation className="h-3.5 w-3.5" /> {label}
    </TooltipButton>
  );
}
